import React, { useState } from 'react';
import { X, ExternalLink } from 'lucide-react';

const hotelCategory = {
  name: 'Hotel Photography & Videography',
  type: 'hotel',
  image: "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9084.JPG",
  hotels: [
    {
      hotelName: 'Crockfords Hotel Resort World Sentosa',
      images: [
        "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9084.JPG",
        "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9078.JPG",
        "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9099.JPG",
        "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9085.JPG",
        "https://storage.googleapis.com/erc-photos/hotel/resort-world-sentosa/DSCF9107.JPG",
      ],
      link: "https://www.instagram.com/reel/DXEYKMmD1ai/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    },
    {
      hotelName: 'Okura Prestige Bangkok',
      images: [
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9694%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9699%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9610%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9617%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9618%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9623%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9629%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9633%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9634%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9657%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9659%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/okura-prestige-bangkok/DSCF9666%20Edited.jpg",
      ],
      link: "https://www.instagram.com/p/DXRhbr0D-Bi/",
    },
    {
      hotelName: 'COMO Singapore',
      images: [
        "https://storage.googleapis.com/erc-photos/hotel/COMO-Singapore/DSCF0392%201%20Edited.jpg",
        // "https://storage.googleapis.com/erc-photos/hotel/COMO-Singapore/DSCF0506%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/COMO-Singapore/DSCF0518%202%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/COMO-Singapore/DSCF0528%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/COMO-Singapore/DSCF0542%20Edited.jpg",
      ],
       link:"https://www.instagram.com/reel/DZ1O_c6zAYC/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    },
    {
      hotelName: 'The Ritz-Carlton, Singapore',
      images: [
        "https://storage.googleapis.com/erc-photos/hotel/ritzcarlton-singapore/DSCF0704%201%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/ritzcarlton-singapore/DSCF0708%202%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/ritzcarlton-singapore/DSCF0709%203%20Edited.jpg",
        // "https://storage.googleapis.com/erc-photos/hotel/ritzcarlton-singapore/DSCF0929%201%20Edited.jpg",
        "https://storage.googleapis.com/erc-photos/hotel/ritzcarlton-singapore/DSCF0720%204%20Edited.jpg",
      ],
    },
  ],
};

const categories = [
  hotelCategory,
  { name: 'Portraits & Graduation', image: "https://storage.googleapis.com/erc-photos/freelances/DSCF8107.jpg", images: ["https://storage.googleapis.com/erc-photos/freelances/DSCF8107.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF8225.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF8259.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF9750.jpg", "https://storage.googleapis.com/erc-photos/freelances/750_8457DIO%20copy.png", "https://storage.googleapis.com/erc-photos/freelances/DSCF7575-Enhanced-NR.jpg", "https://storage.googleapis.com/erc-photos/freelances/GraduationShelen.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF9541.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF9469%20(1).jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF9686.jpg", "https://storage.googleapis.com/erc-photos/freelances/DSCF8051.jpg"] },
  { name: 'Travel', image: "https://storage.googleapis.com/erc-photos/travel/DSCF2369.jpg", images: ["https://storage.googleapis.com/erc-photos/travel/DSCF2369.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF3274.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF5638.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF6104.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF2755.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF6170.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF5507.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF6901.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF6925.jpg", "https://storage.googleapis.com/erc-photos/travel/DSCF6970.jpg", "https://storage.googleapis.com/erc-photos/product/DSC02531.jpg", "https://storage.googleapis.com/erc-photos/product/DSC09917.jpg"] },
  { name: 'Product', image: "https://storage.googleapis.com/erc-photos/product/IMG_20200624_140224%20copy.png", images: ["https://storage.googleapis.com/erc-photos/product/DSC02460-3.jpg", "https://storage.googleapis.com/erc-photos/product/IMG_20200624_140224%20copy.png", "https://storage.googleapis.com/erc-photos/product/IMG_20200703_151610%20(2).jpg", "https://storage.googleapis.com/erc-photos/product/IMG_20200703_153038%20(2).jpg", "https://storage.googleapis.com/erc-photos/product/_MG_7994.jpg", "https://storage.googleapis.com/erc-photos/product/_MG_7990.jpg", "https://storage.googleapis.com/erc-photos/product/DSCF1877%20(1).jpg", "https://storage.googleapis.com/erc-photos/product/BottleCapsAndMarigold.jpeg", "https://storage.googleapis.com/erc-photos/product/IMG_20200623_162947.jpg"] },
  { name: 'Street', image: "https://storage.googleapis.com/erc-photos/street/DSC01616.jpg", images: ["https://storage.googleapis.com/erc-photos/street/DSC01616.jpg", "https://storage.googleapis.com/erc-photos/street/DSC01661%20(1).jpg", "https://storage.googleapis.com/erc-photos/street/DSC01882.jpg", "https://storage.googleapis.com/erc-photos/street/DSC01887.jpg", "https://storage.googleapis.com/erc-photos/street/DSC01929.jpg", "https://storage.googleapis.com/erc-photos/street/DSC02069.jpg", "https://storage.googleapis.com/erc-photos/street/DSC02247.jpg", "https://storage.googleapis.com/erc-photos/street/DSC02319.jpg", "https://storage.googleapis.com/erc-photos/street/DSC02389.jpg", "https://storage.googleapis.com/erc-photos/street/DSC02871%20(1).jpg", "https://storage.googleapis.com/erc-photos/street/IMG_20200226_193816.jpg", "https://storage.googleapis.com/erc-photos/street/IMG_20200304_120508.jpg", "https://storage.googleapis.com/erc-photos/street/LRM_EXPORT_188404638911396_20190910_232901142.jpeg", "https://storage.googleapis.com/erc-photos/street/_MG_0801.jpg"] },
  { name: 'Sport', image: "https://storage.googleapis.com/erc-photos/sport/LRM_EXPORT_57989751381534_20190609_010118157.jpeg", images: ["https://storage.googleapis.com/erc-photos/sport/LRM_EXPORT_57989751381534_20190609_010118157.jpeg", "https://storage.googleapis.com/erc-photos/sport/LRM_EXPORT_90858575178798_20190609_183653105.jpeg", "https://storage.googleapis.com/erc-photos/sport/_MG_7761.JPG", "https://storage.googleapis.com/erc-photos/sport/LRM_EXPORT_57644995148752_20190609_004625168.jpeg", "https://storage.googleapis.com/erc-photos/sport/LRM_EXPORT_51955071972044_20190413_205045647.jpeg", "https://storage.googleapis.com/erc-photos/sport/IMG_8631-02.jpeg", "https://storage.googleapis.com/erc-photos/sport/IMG_7911-01.jpeg", "https://storage.googleapis.com/erc-photos/sport/foto%201.jpg", "https://storage.googleapis.com/erc-photos/sport/IMG_20190703_224434_688.jpg"] },
  { name: 'Stage', image: "https://storage.googleapis.com/erc-photos/stage/IMG_20190707_114710_917.jpg", images: ["https://storage.googleapis.com/erc-photos/stage/IMG_20190627_195822_722.jpg", "https://storage.googleapis.com/erc-photos/stage/IMG_20190707_114710_917.jpg", "https://storage.googleapis.com/erc-photos/stage/IMG_20190707_114152_753.jpg", "https://storage.googleapis.com/erc-photos/stage/IMG_20190705_214909_258.jpg", "https://storage.googleapis.com/erc-photos/stage/IMG_20190705_214714_709.jpg", "https://storage.googleapis.com/erc-photos/stage/_MG_8824-01.jpeg"] },
];

export default function Category() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const openModal = (category) => {
    setSelectedCategory(category);
  };

  const closeModal = () => {
    setSelectedCategory(null);
  };

  return (
    <div>
      {/* Introduction */}
      <div className="mb-12 space-y-4 text-muted">
        <p>
          For the past six years, I&apos;ve turned photography into a serious hobby. My portfolio includes portrait and product photography, with a focus on storytelling and authentic moments.
        </p>
        <p>
          I offer freelance photography services for couples, families, graduation events, and holiday portraits for visitors exploring Singapore.
        </p>
        <p className="text-foreground">
          Feel free to reach out via Instagram for inquiries and bookings.
        </p>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {categories.map((category, index) => (
          <button
            key={index}
            className="group text-left"
            onClick={() => openModal(category)}
          >
            <div className="relative aspect-square overflow-hidden rounded-lg bg-card">
              <img
                src={category.image}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                alt={category.name}
              />
              <div className="absolute inset-0 bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-foreground text-sm font-medium">View Gallery</span>
              </div>
            </div>
            <h3 className="mt-3 text-sm text-foreground font-medium">{category.name}</h3>
          </button>
        ))}
      </div>

      {/* Modal */}
      {selectedCategory && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4">
          <div className="relative bg-card border border-border rounded-lg w-full max-w-5xl max-h-[90vh] overflow-hidden">
            {/* Modal Header */}
            <div className="sticky top-0 bg-card z-10 flex items-center justify-between px-6 py-4 border-b border-border">
              <h2 className="text-xl font-semibold text-foreground">{selectedCategory.name}</h2>
              <button
                className="w-8 h-8 flex items-center justify-center rounded-full bg-border hover:bg-border/80 text-foreground transition-colors"
                onClick={closeModal}
              >
                <X size={16} />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
              {selectedCategory.type === 'hotel' ? (
                <div className="space-y-8">
                  {selectedCategory.hotels.map((hotel, hi) => (
                    <div key={hi}>
                      <div className="flex flex-wrap items-center gap-3 mb-4">
                        <h3 className="text-lg font-medium text-foreground">{hotel.hotelName}</h3>
                        {hotel.link && (
                          <a
                            href={hotel.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium text-background bg-foreground rounded-full hover:bg-foreground/90 transition-colors"
                          >
                            Watch Reel
                            <ExternalLink size={12} />
                          </a>
                        )}
                      </div>
                      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                        {hotel.images.map((image, ii) => (
                          <img
                            key={ii}
                            src={image}
                            className="w-full rounded-lg object-cover aspect-square"
                            alt={`${hotel.hotelName} ${ii + 1}`}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                  {selectedCategory.images.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      className="w-full rounded-lg object-cover aspect-square"
                      alt={`${selectedCategory.name} ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
